import { routerConfigToRouteKey } from '@scorenco/core';

import config from './router-config';

export const routerConfig = config;

export const RouteKey = routerConfigToRouteKey(routerConfig);
